/* 🤖 this file was generated by svg-to-ts */
export const rpgAwesomeIconShovel: {
  name: 'shovel';
  data: string;
} = {
  name: 'shovel',
  data: `<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" x="0" y="0" version="1.1" viewBox="0 0 613 613"><path d="M494.711 238.509h-.002c-16.69 19.715-64.545 40.731-120.77 58.343-2.064-21.385-4.909-39.548-7.642-49.619-7.188-5.298-19.691-6.444-34.052-4.911L271.319 18.611h-63.527l.003.003 65.401 240.615c-14.137 6.507-25.15 13.856-28.8 20.25 2.681 9.878 9.215 26.555 17.998 45.627-59.138 11.671-111.833 16.612-133.48 9.739 32.978 121.505 85.618 210.053 143.805 258.291h191.974c56.474-62.857 74.337-191.331 30.018-354.627z"/></svg>`,
};
